import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from './locales/en/common.json';
import ptBRCommon from './locales/pt-BR/common.json';
import enAuth from './locales/en/auth.json';
import ptBRAuth from './locales/pt-BR/auth.json';
import enApm from './locales/en/apm.json';
import ptBRApm from './locales/pt-BR/apm.json';
import enLogs from './locales/en/logs.json';
import ptBRLogs from './locales/pt-BR/logs.json';
import enMetrics from './locales/en/metrics.json';
import ptBRMetrics from './locales/pt-BR/metrics.json';
import enInfrastructure from './locales/en/infrastructure.json';
import ptBRInfrastructure from './locales/pt-BR/infrastructure.json';
import enMl from './locales/en/ml.json';
import ptBRMl from './locales/pt-BR/ml.json';
import enAlerts from './locales/en/alerts.json';
import ptBRAlerts from './locales/pt-BR/alerts.json';
import enSettings from './locales/en/settings.json';
import ptBRSettings from './locales/pt-BR/settings.json';
import enDatabase from './locales/en/database.json';
import ptBRDatabase from './locales/pt-BR/database.json';
import enSlo from './locales/en/slo.json';
import ptBRSlo from './locales/pt-BR/slo.json';
import enDashboards from './locales/en/dashboards.json';
import ptBRDashboards from './locales/pt-BR/dashboards.json';
import enAgents from './locales/en/agents.json';
import ptBRAgents from './locales/pt-BR/agents.json';
import enStatusPages from './locales/en/status-pages.json';
import ptBRStatusPages from './locales/pt-BR/status-pages.json';
import enCloudScan from './locales/en/cloudScan.json';
import ptBRCloudScan from './locales/pt-BR/cloudScan.json';
import enRum from './locales/en/rum.json';
import ptBRRum from './locales/pt-BR/rum.json';
import enErrors from './locales/en/errors.json';
import ptBRErrors from './locales/pt-BR/errors.json';
import enAnalytics from './locales/en/analytics.json';
import ptBRAnalytics from './locales/pt-BR/analytics.json';
import enRetention from './locales/en/retention.json';
import ptBRRetention from './locales/pt-BR/retention.json';
import enDashboard from './locales/en/dashboard.json';
import ptBRDashboard from './locales/pt-BR/dashboard.json';
import enBilling from './locales/en/billing.json';
import ptBRBilling from './locales/pt-BR/billing.json';
import enNavigation from './locales/en/navigation.json';
import ptBRNavigation from './locales/pt-BR/navigation.json';
import enPlans from './locales/en/plans.json';
import ptBRPlans from './locales/pt-BR/plans.json';
import enWhiteLabel from './locales/en/whiteLabel.json';
import ptBRWhiteLabel from './locales/pt-BR/whiteLabel.json';
import enAffiliate from './locales/en/affiliate.json';
import ptBRAffiliate from './locales/pt-BR/affiliate.json';
import enApmErrors from './locales/en/apm-errors.json';
import ptBRApmErrors from './locales/pt-BR/apm-errors.json';
import enUptime from './locales/en/uptime.json';
import ptBRUptime from './locales/pt-BR/uptime.json';
import enSecurity from './locales/en/security.json';
import ptBRSecurity from './locales/pt-BR/security.json';
import enMobile from './locales/en/mobile.json';
import ptBRMobile from './locales/pt-BR/mobile.json';
import enSeo from './locales/en/seo.json';
import ptBRSeo from './locales/pt-BR/seo.json';
import enLogCollection from './locales/en/logCollection.json';
import ptBRLogCollection from './locales/pt-BR/logCollection.json';
import enOnboarding from './locales/en/onboarding.json';
import ptBROnboarding from './locales/pt-BR/onboarding.json';
import enAssistant from './locales/en/assistant.json';
import ptBRAssistant from './locales/pt-BR/assistant.json';



// Auto-generated imports for new languages
import esAffiliate from './locales/es/affiliate.json';
import esAgents from './locales/es/agents.json';
import esAlerts from './locales/es/alerts.json';
import esAnalytics from './locales/es/analytics.json';
import esApmErrors from './locales/es/apm-errors.json';
import esApm from './locales/es/apm.json';
import esAuth from './locales/es/auth.json';
import esBilling from './locales/es/billing.json';
import esCloudScan from './locales/es/cloud-scan.json';
import esCloudScan from './locales/es/cloudScan.json';
import esCommon from './locales/es/common.json';
import esDashboard from './locales/es/dashboard.json';
import esDashboards from './locales/es/dashboards.json';
import esDatabase from './locales/es/database.json';
import esErrors from './locales/es/errors.json';
import esInfrastructure from './locales/es/infrastructure.json';
import esLogCollection from './locales/es/logCollection.json';
import esLogs from './locales/es/logs.json';
import esMetrics from './locales/es/metrics.json';
import esMl from './locales/es/ml.json';
import esMobile from './locales/es/mobile.json';
import esNavigation from './locales/es/navigation.json';
import esObservability from './locales/es/observability.json';
import esOnboarding from './locales/es/onboarding.json';
import esPlans from './locales/es/plans.json';
import esRetention from './locales/es/retention.json';
import esRum from './locales/es/rum.json';
import esSecurity from './locales/es/security.json';
import esSeo from './locales/es/seo.json';
import esSettings from './locales/es/settings.json';
import esSlo from './locales/es/slo.json';
import esStatusPages from './locales/es/status-pages.json';
import esUptime from './locales/es/uptime.json';
import esWhiteLabel from './locales/es/whiteLabel.json';
import esAssistant from './locales/es/assistant.json';

import frAffiliate from './locales/fr/affiliate.json';
import frAgents from './locales/fr/agents.json';
import frAlerts from './locales/fr/alerts.json';
import frAnalytics from './locales/fr/analytics.json';
import frApmErrors from './locales/fr/apm-errors.json';
import frApm from './locales/fr/apm.json';
import frAuth from './locales/fr/auth.json';
import frBilling from './locales/fr/billing.json';
import frCloudScan from './locales/fr/cloud-scan.json';
import frCloudScan from './locales/fr/cloudScan.json';
import frCommon from './locales/fr/common.json';
import frDashboard from './locales/fr/dashboard.json';
import frDashboards from './locales/fr/dashboards.json';
import frDatabase from './locales/fr/database.json';
import frErrors from './locales/fr/errors.json';
import frInfrastructure from './locales/fr/infrastructure.json';
import frLogCollection from './locales/fr/logCollection.json';
import frLogs from './locales/fr/logs.json';
import frMetrics from './locales/fr/metrics.json';
import frMl from './locales/fr/ml.json';
import frMobile from './locales/fr/mobile.json';
import frNavigation from './locales/fr/navigation.json';
import frObservability from './locales/fr/observability.json';
import frOnboarding from './locales/fr/onboarding.json';
import frPlans from './locales/fr/plans.json';
import frRetention from './locales/fr/retention.json';
import frRum from './locales/fr/rum.json';
import frSecurity from './locales/fr/security.json';
import frSeo from './locales/fr/seo.json';
import frSettings from './locales/fr/settings.json';
import frSlo from './locales/fr/slo.json';
import frStatusPages from './locales/fr/status-pages.json';
import frUptime from './locales/fr/uptime.json';
import frWhiteLabel from './locales/fr/whiteLabel.json';
import frAssistant from './locales/fr/assistant.json';

import deAffiliate from './locales/de/affiliate.json';
import deAgents from './locales/de/agents.json';
import deAlerts from './locales/de/alerts.json';
import deAnalytics from './locales/de/analytics.json';
import deApmErrors from './locales/de/apm-errors.json';
import deApm from './locales/de/apm.json';
import deAuth from './locales/de/auth.json';
import deBilling from './locales/de/billing.json';
import deCloudScan from './locales/de/cloud-scan.json';
import deCloudScan from './locales/de/cloudScan.json';
import deCommon from './locales/de/common.json';
import deDashboard from './locales/de/dashboard.json';
import deDashboards from './locales/de/dashboards.json';
import deDatabase from './locales/de/database.json';
import deErrors from './locales/de/errors.json';
import deInfrastructure from './locales/de/infrastructure.json';
import deLogCollection from './locales/de/logCollection.json';
import deLogs from './locales/de/logs.json';
import deMetrics from './locales/de/metrics.json';
import deMl from './locales/de/ml.json';
import deMobile from './locales/de/mobile.json';
import deNavigation from './locales/de/navigation.json';
import deObservability from './locales/de/observability.json';
import deOnboarding from './locales/de/onboarding.json';
import dePlans from './locales/de/plans.json';
import deRetention from './locales/de/retention.json';
import deRum from './locales/de/rum.json';
import deSecurity from './locales/de/security.json';
import deSeo from './locales/de/seo.json';
import deSettings from './locales/de/settings.json';
import deSlo from './locales/de/slo.json';
import deStatusPages from './locales/de/status-pages.json';
import deUptime from './locales/de/uptime.json';
import deWhiteLabel from './locales/de/whiteLabel.json';
import deAssistant from './locales/de/assistant.json';

import itAffiliate from './locales/it/affiliate.json';
import itAgents from './locales/it/agents.json';
import itAlerts from './locales/it/alerts.json';
import itAnalytics from './locales/it/analytics.json';
import itApmErrors from './locales/it/apm-errors.json';
import itApm from './locales/it/apm.json';
import itAuth from './locales/it/auth.json';
import itBilling from './locales/it/billing.json';
import itCloudScan from './locales/it/cloud-scan.json';
import itCloudScan from './locales/it/cloudScan.json';
import itCommon from './locales/it/common.json';
import itDashboard from './locales/it/dashboard.json';
import itDashboards from './locales/it/dashboards.json';
import itDatabase from './locales/it/database.json';
import itErrors from './locales/it/errors.json';
import itInfrastructure from './locales/it/infrastructure.json';
import itLogCollection from './locales/it/logCollection.json';
import itLogs from './locales/it/logs.json';
import itMetrics from './locales/it/metrics.json';
import itMl from './locales/it/ml.json';
import itMobile from './locales/it/mobile.json';
import itNavigation from './locales/it/navigation.json';
import itObservability from './locales/it/observability.json';
import itOnboarding from './locales/it/onboarding.json';
import itPlans from './locales/it/plans.json';
import itRetention from './locales/it/retention.json';
import itRum from './locales/it/rum.json';
import itSecurity from './locales/it/security.json';
import itSeo from './locales/it/seo.json';
import itSettings from './locales/it/settings.json';
import itSlo from './locales/it/slo.json';
import itStatusPages from './locales/it/status-pages.json';
import itUptime from './locales/it/uptime.json';
import itWhiteLabel from './locales/it/whiteLabel.json';
import itAssistant from './locales/it/assistant.json';

import plAffiliate from './locales/pl/affiliate.json';
import plAgents from './locales/pl/agents.json';
import plAlerts from './locales/pl/alerts.json';
import plAnalytics from './locales/pl/analytics.json';
import plApmErrors from './locales/pl/apm-errors.json';
import plApm from './locales/pl/apm.json';
import plAuth from './locales/pl/auth.json';
import plBilling from './locales/pl/billing.json';
import plCloudScan from './locales/pl/cloud-scan.json';
import plCloudScan from './locales/pl/cloudScan.json';
import plCommon from './locales/pl/common.json';
import plDashboard from './locales/pl/dashboard.json';
import plDashboards from './locales/pl/dashboards.json';
import plDatabase from './locales/pl/database.json';
import plErrors from './locales/pl/errors.json';
import plInfrastructure from './locales/pl/infrastructure.json';
import plLogCollection from './locales/pl/logCollection.json';
import plLogs from './locales/pl/logs.json';
import plMetrics from './locales/pl/metrics.json';
import plMl from './locales/pl/ml.json';
import plMobile from './locales/pl/mobile.json';
import plNavigation from './locales/pl/navigation.json';
import plObservability from './locales/pl/observability.json';
import plOnboarding from './locales/pl/onboarding.json';
import plPlans from './locales/pl/plans.json';
import plRetention from './locales/pl/retention.json';
import plRum from './locales/pl/rum.json';
import plSecurity from './locales/pl/security.json';
import plSeo from './locales/pl/seo.json';
import plSettings from './locales/pl/settings.json';
import plSlo from './locales/pl/slo.json';
import plStatusPages from './locales/pl/status-pages.json';
import plUptime from './locales/pl/uptime.json';
import plWhiteLabel from './locales/pl/whiteLabel.json';
import plAssistant from './locales/pl/assistant.json';

import daAffiliate from './locales/da/affiliate.json';
import daAgents from './locales/da/agents.json';
import daAlerts from './locales/da/alerts.json';
import daAnalytics from './locales/da/analytics.json';
import daApmErrors from './locales/da/apm-errors.json';
import daApm from './locales/da/apm.json';
import daAuth from './locales/da/auth.json';
import daBilling from './locales/da/billing.json';
import daCloudScan from './locales/da/cloud-scan.json';
import daCloudScan from './locales/da/cloudScan.json';
import daCommon from './locales/da/common.json';
import daDashboard from './locales/da/dashboard.json';
import daDashboards from './locales/da/dashboards.json';
import daDatabase from './locales/da/database.json';
import daErrors from './locales/da/errors.json';
import daInfrastructure from './locales/da/infrastructure.json';
import daLogCollection from './locales/da/logCollection.json';
import daLogs from './locales/da/logs.json';
import daMetrics from './locales/da/metrics.json';
import daMl from './locales/da/ml.json';
import daMobile from './locales/da/mobile.json';
import daNavigation from './locales/da/navigation.json';
import daObservability from './locales/da/observability.json';
import daOnboarding from './locales/da/onboarding.json';
import daPlans from './locales/da/plans.json';
import daRetention from './locales/da/retention.json';
import daRum from './locales/da/rum.json';
import daSecurity from './locales/da/security.json';
import daSeo from './locales/da/seo.json';
import daSettings from './locales/da/settings.json';
import daSlo from './locales/da/slo.json';
import daStatusPages from './locales/da/status-pages.json';
import daUptime from './locales/da/uptime.json';
import daWhiteLabel from './locales/da/whiteLabel.json';
import daAssistant from './locales/da/assistant.json';

import filAffiliate from './locales/fil/affiliate.json';
import filAgents from './locales/fil/agents.json';
import filAlerts from './locales/fil/alerts.json';
import filAnalytics from './locales/fil/analytics.json';
import filApmErrors from './locales/fil/apm-errors.json';
import filApm from './locales/fil/apm.json';
import filAuth from './locales/fil/auth.json';
import filBilling from './locales/fil/billing.json';
import filCloudScan from './locales/fil/cloud-scan.json';
import filCloudScan from './locales/fil/cloudScan.json';
import filCommon from './locales/fil/common.json';
import filDashboard from './locales/fil/dashboard.json';
import filDashboards from './locales/fil/dashboards.json';
import filDatabase from './locales/fil/database.json';
import filErrors from './locales/fil/errors.json';
import filInfrastructure from './locales/fil/infrastructure.json';
import filLogCollection from './locales/fil/logCollection.json';
import filLogs from './locales/fil/logs.json';
import filMetrics from './locales/fil/metrics.json';
import filMl from './locales/fil/ml.json';
import filMobile from './locales/fil/mobile.json';
import filNavigation from './locales/fil/navigation.json';
import filObservability from './locales/fil/observability.json';
import filOnboarding from './locales/fil/onboarding.json';
import filPlans from './locales/fil/plans.json';
import filRetention from './locales/fil/retention.json';
import filRum from './locales/fil/rum.json';
import filSecurity from './locales/fil/security.json';
import filSeo from './locales/fil/seo.json';
import filSettings from './locales/fil/settings.json';
import filSlo from './locales/fil/slo.json';
import filStatusPages from './locales/fil/status-pages.json';
import filUptime from './locales/fil/uptime.json';
import filWhiteLabel from './locales/fil/whiteLabel.json';
import filAssistant from './locales/fil/assistant.json';

import zhAffiliate from './locales/zh/affiliate.json';
import zhAgents from './locales/zh/agents.json';
import zhAlerts from './locales/zh/alerts.json';
import zhAnalytics from './locales/zh/analytics.json';
import zhApmErrors from './locales/zh/apm-errors.json';
import zhApm from './locales/zh/apm.json';
import zhAuth from './locales/zh/auth.json';
import zhBilling from './locales/zh/billing.json';
import zhCloudScan from './locales/zh/cloud-scan.json';
import zhCloudScan from './locales/zh/cloudScan.json';
import zhCommon from './locales/zh/common.json';
import zhDashboard from './locales/zh/dashboard.json';
import zhDashboards from './locales/zh/dashboards.json';
import zhDatabase from './locales/zh/database.json';
import zhErrors from './locales/zh/errors.json';
import zhInfrastructure from './locales/zh/infrastructure.json';
import zhLogCollection from './locales/zh/logCollection.json';
import zhLogs from './locales/zh/logs.json';
import zhMetrics from './locales/zh/metrics.json';
import zhMl from './locales/zh/ml.json';
import zhMobile from './locales/zh/mobile.json';
import zhNavigation from './locales/zh/navigation.json';
import zhObservability from './locales/zh/observability.json';
import zhOnboarding from './locales/zh/onboarding.json';
import zhPlans from './locales/zh/plans.json';
import zhRetention from './locales/zh/retention.json';
import zhRum from './locales/zh/rum.json';
import zhSecurity from './locales/zh/security.json';
import zhSeo from './locales/zh/seo.json';
import zhSettings from './locales/zh/settings.json';
import zhSlo from './locales/zh/slo.json';
import zhStatusPages from './locales/zh/status-pages.json';
import zhUptime from './locales/zh/uptime.json';
import zhWhiteLabel from './locales/zh/whiteLabel.json';
import zhAssistant from './locales/zh/assistant.json';

const resources = {
  en: {
    common: enCommon,
    dashboard: enDashboard,
    auth: enAuth,
    apm: enApm,
    'apm-errors': enApmErrors,
    logs: enLogs,
    metrics: enMetrics,
    infrastructure: enInfrastructure,
    ml: enMl,
    alerts: enAlerts,
    settings: enSettings,
    database: enDatabase,
    slo: enSlo,
    dashboards: enDashboards,
    agents: enAgents,
    statusPages: enStatusPages,
    cloudScan: enCloudScan,
    rum: enRum,
    errors: enErrors,
    analytics: enAnalytics,
    retention: enRetention,
    billing: enBilling,
    navigation: enNavigation,
    plans: enPlans,
    whiteLabel: enWhiteLabel,
    affiliate: enAffiliate,
    uptime: enUptime,
    security: enSecurity,
    mobile: enMobile,
    seo: enSeo,
    logCollection: enLogCollection,
    onboarding: enOnboarding,
    assistant: enAssistant,
  },
  'pt-BR': {
    common: ptBRCommon,
    dashboard: ptBRDashboard,
    auth: ptBRAuth,
    apm: ptBRApm,
    'apm-errors': ptBRApmErrors,
    logs: ptBRLogs,
    metrics: ptBRMetrics,
    infrastructure: ptBRInfrastructure,
    ml: ptBRMl,
    alerts: ptBRAlerts,
    settings: ptBRSettings,
    database: ptBRDatabase,
    slo: ptBRSlo,
    dashboards: ptBRDashboards,
    agents: ptBRAgents,
    statusPages: ptBRStatusPages,
    cloudScan: ptBRCloudScan,
    rum: ptBRRum,
    errors: ptBRErrors,
    analytics: ptBRAnalytics,
    retention: ptBRRetention,
    billing: ptBRBilling,
    navigation: ptBRNavigation,
    plans: ptBRPlans,
    whiteLabel: ptBRWhiteLabel,
    affiliate: ptBRAffiliate,
    uptime: ptBRUptime,
    security: ptBRSecurity,
    mobile: ptBRMobile,
    seo: ptBRSeo,
    logCollection: ptBRLogCollection,
    onboarding: ptBROnboarding,
    assistant: ptBRAssistant,
  },
  es: {
    affiliate: esAffiliate,
    agents: esAgents,
    alerts: esAlerts,
    analytics: esAnalytics,
    'apm-errors': esApmErrors,
    apm: esApm,
    auth: esAuth,
    billing: esBilling,
    'cloud-scan': esCloudScan,
    cloudScan: esCloudScan,
    common: esCommon,
    dashboard: esDashboard,
    dashboards: esDashboards,
    database: esDatabase,
    errors: esErrors,
    infrastructure: esInfrastructure,
    logCollection: esLogCollection,
    logs: esLogs,
    metrics: esMetrics,
    ml: esMl,
    mobile: esMobile,
    navigation: esNavigation,
    observability: esObservability,
    onboarding: esOnboarding,
    plans: esPlans,
    retention: esRetention,
    rum: esRum,
    security: esSecurity,
    seo: esSeo,
    settings: esSettings,
    slo: esSlo,
    statusPages: esStatusPages,
    uptime: esUptime,
    whiteLabel: esWhiteLabel,
    assistant: esAssistant,
  },
  fr: {
    affiliate: frAffiliate,
    agents: frAgents,
    alerts: frAlerts,
    analytics: frAnalytics,
    'apm-errors': frApmErrors,
    apm: frApm,
    auth: frAuth,
    billing: frBilling,
    'cloud-scan': frCloudScan,
    cloudScan: frCloudScan,
    common: frCommon,
    dashboard: frDashboard,
    dashboards: frDashboards,
    database: frDatabase,
    errors: frErrors,
    infrastructure: frInfrastructure,
    logCollection: frLogCollection,
    logs: frLogs,
    metrics: frMetrics,
    ml: frMl,
    mobile: frMobile,
    navigation: frNavigation,
    observability: frObservability,
    onboarding: frOnboarding,
    plans: frPlans,
    retention: frRetention,
    rum: frRum,
    security: frSecurity,
    seo: frSeo,
    settings: frSettings,
    slo: frSlo,
    statusPages: frStatusPages,
    uptime: frUptime,
    whiteLabel: frWhiteLabel,
    assistant: frAssistant,
  },
  de: {
    affiliate: deAffiliate,
    agents: deAgents,
    alerts: deAlerts,
    analytics: deAnalytics,
    'apm-errors': deApmErrors,
    apm: deApm,
    auth: deAuth,
    billing: deBilling,
    'cloud-scan': deCloudScan,
    cloudScan: deCloudScan,
    common: deCommon,
    dashboard: deDashboard,
    dashboards: deDashboards,
    database: deDatabase,
    errors: deErrors,
    infrastructure: deInfrastructure,
    logCollection: deLogCollection,
    logs: deLogs,
    metrics: deMetrics,
    ml: deMl,
    mobile: deMobile,
    navigation: deNavigation,
    observability: deObservability,
    onboarding: deOnboarding,
    plans: dePlans,
    retention: deRetention,
    rum: deRum,
    security: deSecurity,
    seo: deSeo,
    settings: deSettings,
    slo: deSlo,
    statusPages: deStatusPages,
    uptime: deUptime,
    whiteLabel: deWhiteLabel,
    assistant: deAssistant,
  },
  it: {
    affiliate: itAffiliate,
    agents: itAgents,
    alerts: itAlerts,
    analytics: itAnalytics,
    'apm-errors': itApmErrors,
    apm: itApm,
    auth: itAuth,
    billing: itBilling,
    'cloud-scan': itCloudScan,
    cloudScan: itCloudScan,
    common: itCommon,
    dashboard: itDashboard,
    dashboards: itDashboards,
    database: itDatabase,
    errors: itErrors,
    infrastructure: itInfrastructure,
    logCollection: itLogCollection,
    logs: itLogs,
    metrics: itMetrics,
    ml: itMl,
    mobile: itMobile,
    navigation: itNavigation,
    observability: itObservability,
    onboarding: itOnboarding,
    plans: itPlans,
    retention: itRetention,
    rum: itRum,
    security: itSecurity,
    seo: itSeo,
    settings: itSettings,
    slo: itSlo,
    statusPages: itStatusPages,
    uptime: itUptime,
    whiteLabel: itWhiteLabel,
    assistant: itAssistant,
  },
  pl: {
    affiliate: plAffiliate,
    agents: plAgents,
    alerts: plAlerts,
    analytics: plAnalytics,
    'apm-errors': plApmErrors,
    apm: plApm,
    auth: plAuth,
    billing: plBilling,
    'cloud-scan': plCloudScan,
    cloudScan: plCloudScan,
    common: plCommon,
    dashboard: plDashboard,
    dashboards: plDashboards,
    database: plDatabase,
    errors: plErrors,
    infrastructure: plInfrastructure,
    logCollection: plLogCollection,
    logs: plLogs,
    metrics: plMetrics,
    ml: plMl,
    mobile: plMobile,
    navigation: plNavigation,
    observability: plObservability,
    onboarding: plOnboarding,
    plans: plPlans,
    retention: plRetention,
    rum: plRum,
    security: plSecurity,
    seo: plSeo,
    settings: plSettings,
    slo: plSlo,
    statusPages: plStatusPages,
    uptime: plUptime,
    whiteLabel: plWhiteLabel,
    assistant: plAssistant,
  },
  da: {
    affiliate: daAffiliate,
    agents: daAgents,
    alerts: daAlerts,
    analytics: daAnalytics,
    'apm-errors': daApmErrors,
    apm: daApm,
    auth: daAuth,
    billing: daBilling,
    'cloud-scan': daCloudScan,
    cloudScan: daCloudScan,
    common: daCommon,
    dashboard: daDashboard,
    dashboards: daDashboards,
    database: daDatabase,
    errors: daErrors,
    infrastructure: daInfrastructure,
    logCollection: daLogCollection,
    logs: daLogs,
    metrics: daMetrics,
    ml: daMl,
    mobile: daMobile,
    navigation: daNavigation,
    observability: daObservability,
    onboarding: daOnboarding,
    plans: daPlans,
    retention: daRetention,
    rum: daRum,
    security: daSecurity,
    seo: daSeo,
    settings: daSettings,
    slo: daSlo,
    statusPages: daStatusPages,
    uptime: daUptime,
    whiteLabel: daWhiteLabel,
    assistant: daAssistant,
  },
  fil: {
    affiliate: filAffiliate,
    agents: filAgents,
    alerts: filAlerts,
    analytics: filAnalytics,
    'apm-errors': filApmErrors,
    apm: filApm,
    auth: filAuth,
    billing: filBilling,
    'cloud-scan': filCloudScan,
    cloudScan: filCloudScan,
    common: filCommon,
    dashboard: filDashboard,
    dashboards: filDashboards,
    database: filDatabase,
    errors: filErrors,
    infrastructure: filInfrastructure,
    logCollection: filLogCollection,
    logs: filLogs,
    metrics: filMetrics,
    ml: filMl,
    mobile: filMobile,
    navigation: filNavigation,
    observability: filObservability,
    onboarding: filOnboarding,
    plans: filPlans,
    retention: filRetention,
    rum: filRum,
    security: filSecurity,
    seo: filSeo,
    settings: filSettings,
    slo: filSlo,
    statusPages: filStatusPages,
    uptime: filUptime,
    whiteLabel: filWhiteLabel,
    assistant: filAssistant,
  },
  zh: {
    affiliate: zhAffiliate,
    agents: zhAgents,
    alerts: zhAlerts,
    analytics: zhAnalytics,
    'apm-errors': zhApmErrors,
    apm: zhApm,
    auth: zhAuth,
    billing: zhBilling,
    'cloud-scan': zhCloudScan,
    cloudScan: zhCloudScan,
    common: zhCommon,
    dashboard: zhDashboard,
    dashboards: zhDashboards,
    database: zhDatabase,
    errors: zhErrors,
    infrastructure: zhInfrastructure,
    logCollection: zhLogCollection,
    logs: zhLogs,
    metrics: zhMetrics,
    ml: zhMl,
    mobile: zhMobile,
    navigation: zhNavigation,
    observability: zhObservability,
    onboarding: zhOnboarding,
    plans: zhPlans,
    retention: zhRetention,
    rum: zhRum,
    security: zhSecurity,
    seo: zhSeo,
    settings: zhSettings,
    slo: zhSlo,
    statusPages: zhStatusPages,
    uptime: zhUptime,
    whiteLabel: zhWhiteLabel,
    assistant: zhAssistant,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS: 'common',
    fallbackLng: 'en',
    lng: localStorage.getItem('language') || 'pt-BR',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
